Chart.pluginService.register({
    beforeRender: function (chart) {
        if (chart.config.options.showAllTooltips) {
            // create an array of tooltips
            // we can't use the chart tooltip because there is only one tooltip per chart
            chart.pluginTooltips = [];
            chart.config.data.datasets.forEach(function (dataset, i) {
                chart.getDatasetMeta(i).data.forEach(function (sector, j) {
                    chart.pluginTooltips.push(new Chart.Tooltip({
                        _chart: chart.chart,
                        _chartInstance: chart,
                        _data: chart.data,
                        _options: chart.options.tooltips,
                        _active: [sector]
                    }, chart));
                });
            });

            // turn off normal tooltips
            chart.options.tooltips.enabled = false;
        }
    },
    afterDraw: function (chart, easing) {
        if (chart.config.options.showAllTooltips) {
            // we don't want the permanent tooltips to animate, so don't do anything till the animation runs atleast once
            if (!chart.allTooltipsOnce) {
                if (easing !== 1)
                    return;
                chart.allTooltipsOnce = true;
            }

            // turn on tooltips
            chart.options.tooltips.enabled = true;
            Chart.helpers.each(chart.pluginTooltips, function (tooltip) {
                tooltip.initialize();
                tooltip.update();
                // we don't actually need this since we are not animating tooltips
                tooltip.pivot();
                tooltip.transition(easing).draw();
            });
            chart.options.tooltips.enabled = false;
        }
    }
});

window.chartColors = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)'
};

var configEmergencies = {
    type: 'doughnut',
    data: {
        datasets: [{
            data: [
                38220,
                4112,
                25927,
                16445,
                19430,
                38512
            ],
            backgroundColor: [
                '#E38F3E',
                '#A68262',
                '#005DC2',
                '#E38F3E',
                '#A68262',
                '#005DC2',
            ],
            weight: 0.9
            //label: 'Urgències'
        }],
        /*labels: [
            'Mèdiques',
            'Quirúrgiques',
            'Traumatològiques',
            'Maternoinfanitls',
            'Psiquiàtriques',
            'Primer nivell',
        ]*/
    },
    options: {
        tooltips: {
            enabled: false
        },
        responsive: true,
        cutoutPercentage: 40,
        /*legend: {
            position: 'bottom',
            fontFamily: 'Lato,Helvetica,Arial,sans-serif',
        },
        title: {
            display: false,
            text: ''
        },*/
        animation: {
            animateScale: true,
            animateRotate: true,
            duration: 2000
        }
    }
};

var configCasuistica = {
    type: 'doughnut',
    data: {
        datasets: [{
            data: [
                30.9,
                7.5,
                25.4,
                10,
                8.3,
                4.8,
                17.4
            ],
            backgroundColor: [
                '#E38F3E',
                '#A68262',
                '#005DC2',
                '#E38F3E',
                '#005DC2',
                '#E38F3E',
                '#A68262',
            ],
            weight: 0.9
        }],
    },
    options: {
        tooltips: {
            enabled: false
        },
        // responsive: true,
        // cutoutPercentage: 40,
        // animation: {
        //     animateScale: true,
        //     animateRotate: true,
        //     duration: 2000
        // },
    }
};

var configExternes1 = {
    type: 'horizontalBar',
    data: {
        labels: ['2019', '2018'],
        datasets: [{
            label: 'Primeres visites',
            backgroundColor: ['#e38f3e', '#ebc7a2'],
            data: [
                155072,
                151025
            ]
        }, {
            label: 'Visites successives',
            backgroundColor: ['#004fa5', '#85a9d0'],
            data: [
                509840,
                503269
            ]
        }]
    },
    options: {
        // elements: {
        //     rectangle: {
        //         borderWidth: 1,
        //         borderColor: "#fff"
        //     }
        // },
        responsive: true,
        legend: {
            display: false
        },
        tooltips: {
            enabled: false
        },
        title: {
            display: false
        },
        scales: {
            xAxes: [{
                stacked: true,
                display: false
            }],
            yAxes: [{
                stacked: true,
                display: false
            }]
        }
    }
};

var configExternes2 = {
    type: 'horizontalBar',
    data: {
        labels: ['2019', '2018'],
        datasets: [{
            backgroundColor: ['#B3B3B3', '#D9D9D9'],
            data: [
                268631,
                258831
            ]
        }, {
            // backgroundColor: ['#ffffff', '#ffffff'],
            backgroundColor: ['transparent', 'transparent'],
            data: [
                0,
                9800
            ]
        }]
    },
    options: {
        responsive: true,
        legend: {
            display: false
        },
        tooltips: {
            enabled: false
        },
        title: {
            display: false
        },
        scales: {
            xAxes: [{
                stacked: true,
                display: false
            }],
            yAxes: [{
                stacked: true,
                display: false
            }]
        }
    }
};

var ico_home = new Image();
ico_home.src = '/media/img/ico-home.svg';

var ico_dona = new Image();
ico_dona.src = '/media/img/ico-dona.svg';

var configDones = {
    type: 'line',
    data: {
        labels: ['2008', '2014', '2016', '2018', '2020'],
        datasets: [{
            label: 'Homes',
            backgroundColor: "#e38f3e",
            borderColor: "#e38f3e",
            pointStyle: ico_home,
            data: [
                45,
                38,
                37,
                38,
                32
            ],
            borderWidth: 1,
            lineTension: 0,
            fill: false,
        }, {
            label: 'Dones',
            fill: false,
            backgroundColor: "#004fa5",
            borderColor: "#004fa5",
            pointStyle: ico_dona,
            data: [
                6,
                10,
                9,
                12,
                18
            ],
            borderWidth: 1,
            lineTension: 0,
            fill: false,
        }]
    },
    options: {
        responsive: true,
        title: {
            display: false,
            // text: 'Chart.js Line Chart'
        },
        legend: {
            display: false
        },
        hover: {
            mode: 'nearest',
            intersect: true
        },
        scales: {
            xAxes: [{
                display: true,
                scaleLabel: {
                    display: false,
                    labelString: 'Month'
                }
            }],
            yAxes: [{
                display: false,
                // scaleLabel: {
                //     display: true,
                //     labelString: 'Value'
                // }
            }]
        },
        showAllTooltips: true,
        tooltips: {
            mode: 'index',
            intersect: false,
            callbacks: {
                label: function (tooltipItem) {
                    return tooltipItem.value;
                },
                title: function (tooltipItem) {
                    return;
                },
            },
            displayColors: false,
            caretSize: 0,
            xAlign: 'center',
            yAlign: 'top',
        }
    }
};

var configActivitats = {
    type: 'doughnut',
    data: {
        datasets: [{
            data: [
                11.12,
                216.84,
                11.12,
                38.92
            ],
            backgroundColor: [
                '#A68262',
                '#E38F3E',
                '#005DC2',
                '#E38F3E'
            ],
            weight: 0.9
        }],
    },
    options: {
        tooltips: {
            enabled: false
        },
        responsive: true,
        cutoutPercentage: 40,
        animation: {
            animateScale: true,
            animateRotate: true,
            duration: 2000
        }
    }
};

var configOrigen = {
    type: 'doughnut',
    data: {
        datasets: [{
            data: [
                21,
                21,
                58
            ],
            backgroundColor: [
                '#A68262',
                '#E38F3E',
                '#005DC2'
            ],
            weight: 0.9
        }],
    },
    options: {
        tooltips: {
            enabled: false
        },
        responsive: true,
        cutoutPercentage: 40,
        animation: {
            animateScale: true,
            animateRotate: true,
            duration: 2000
        }
    }
};

var configDestinacio = {
    type: 'doughnut',
    data: {
        datasets: [{
            data: [
                8.2,
                44.4,
                19.5,
                27.9
            ],
            backgroundColor: [
                '#A68262',
                '#E38F3E',
                '#005DC2',
                '#E38F3E'
            ],
            weight: 0.9
        }],
    },
    options: {
        tooltips: {
            enabled: false
        },
        responsive: true,
        cutoutPercentage: 40,
        animation: {
            animateScale: true,
            animateRotate: true,
            duration: 2000
        }
    }
};

var configMitjans = {
    type: 'doughnut',
    data: {
        datasets: [{
            data: [
                17,
                3,
                6,
                74

            ],
            backgroundColor: [
                '#A68262',
                '#E38F3E',
                '#005DC2',
                '#E38F3E'
            ],
            weight: 0.9
        }],
    },
    options: {
        tooltips: {
            enabled: false
        },
        responsive: true,
        cutoutPercentage: 40,
        animation: {
            animateScale: true,
            animateRotate: true,
            duration: 2000
        }
    }
};

var configTipusNoticia = {
    type: 'doughnut',
    data: {
        datasets: [{
            data: [
                61.4,
                6,
                1.5,
                3.6,
                27.5,
            ],
            backgroundColor: [
                '#A68262',
                '#E38F3E',
                '#005DC2',
                '#A68262',
                '#E38F3E'
            ],
            weight: 0.9
        }],
    },
    options: {
        tooltips: {
            enabled: false
        },
        responsive: true,
        cutoutPercentage: 40,
        animation: {
            animateScale: true,
            animateRotate: true,
            duration: 2000
        }
    }
};

var configDespesa = {
    type: 'bar',
    data: {
        labels: ['2014', '2015', '2016', '2017', '2018', '2019'],
        datasets: [{
            data: [
                289,
                299,
                301,
                315,
                332,
                346
            ],
            backgroundColor: [
                '#ECC299',
                '#ECC299',
                '#ECC299',
                '#ECC299',
                '#ECC299',
                '#e38f3e'
            ]
        }],
    },
    options: {
        title: {
            display: false,
        },
        legend: {
            display: false
        },
        scales: {
            xAxes: [{
                display: true,
                // scaleLabel: {
                //     display: false,
                //     labelString: 'Month'
                // }
            }],
            yAxes: [{
                display: false,
                scaleLabel: {
                    display: false,
                    // labelString: 'Value'
                }
            }]
        },
        responsive: true,
        showAllTooltips: true,
        tooltips: {
            callbacks: {
                label: function (tooltipItem) {
                    return tooltipItem.value;
                },
                title: function (tooltipItem) {
                    return;
                },
            },
            displayColors: false,
            caretSize: 0,
            xAlign: 'center',
            yAlign: 'bottom',
        }
    }
};

var configInversions = {
    type: 'doughnut',
    data: {
        datasets: [{
            data: [
                38.8,
                2.1,
                12.2,
                46.9
            ],
            backgroundColor: [
                '#A68262',
                '#E38F3E',
                '#005DC2',
                '#E38F3E'
            ],
            weight: 0.9
        }],
    },
    options: {
        tooltips: {
            enabled: false
        },
        responsive: true,
        cutoutPercentage: 40,
        animation: {
            animateScale: true,
            animateRotate: true,
            duration: 2000
        }
    }
};

$(document).ready(function () {
    ("use strict");
    $('#chart-casuistica').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-casuistica').getContext('2d');
            window.myDoughnut = new Chart(ctx, configCasuistica);
        },
    });
    $('#chart-externes-1').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-externes-1').getContext('2d');
            window.myHorizontalBar = new Chart(ctx, configExternes1);
        },
    });
    $('#chart-externes-2').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-externes-2').getContext('2d');
            window.myHorizontalBar = new Chart(ctx, configExternes2);
        },
    });
    $('#chart-urgencies').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-urgencies').getContext('2d');
            window.myDoughnut = new Chart(ctx, configEmergencies);
        },
    });
    $('#chart-dones').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-dones').getContext('2d');
            window.myLine = new Chart(ctx, configDones);
        },
    });
    $('#chart-activitats').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-activitats').getContext('2d');
            window.myDoughnut = new Chart(ctx, configActivitats);
        },
    });
    $('#chart-origen').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-origen').getContext('2d');
            window.myDoughnut = new Chart(ctx, configOrigen);
        },
    });
    $('#chart-destinacio').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-destinacio').getContext('2d');
            window.myDoughnut = new Chart(ctx, configDestinacio);
        },
    });
    $('#chart-mitjans').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-mitjans').getContext('2d');
            window.myDoughnut = new Chart(ctx, configMitjans);
        },
    });
    $('#chart-tipus-noticia').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-tipus-noticia').getContext('2d');
            window.myDoughnut = new Chart(ctx, configTipusNoticia);
        },
    });
    $('#chart-despesa').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-despesa').getContext('2d');
            window.myBar = new Chart(ctx, configDespesa);
        },
    });
    $('#chart-inversions').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-inversions').getContext('2d');
            window.myDoughnut = new Chart(ctx, configInversions);
        },
    });
});
